import React, { useEffect, useState } from 'react';
import { StepsWidgetSC } from './steps-widget.styled';
import Badge from '../../../../../components/badge';
import Button from '../../../../../components/button';
import { FormattedMessage } from 'react-intl';
//@ts-ignore
import { CircleProgress } from 'react-gradient-progress';
import { TBehavioralStepItem } from 'types/life-id';
import {
  CIRCLE_CHART_GRADIENT_LEVELS,
  getPercentage,
} from '../../../../../helpers/behavioral-helpers';
import { ReactComponent as StepsIcon } from '../../../../../assets/svg/icon-steps.svg';

interface StepsWidgetProps {
  data: TBehavioralStepItem | undefined;
  onDetailOpen?: () => void;
  isEmpty?: boolean;
}

const StepsWidget: React.FC<StepsWidgetProps> = ({ data, onDetailOpen, isEmpty }) => {
  const [percentage, setPercentage] = useState<number>(0);

  useEffect(() => {
    if (data?.goal && data?.value) {
      setPercentage(getPercentage(data.value, data.goal));
    }
  }, [data]);

  return (
    <StepsWidgetSC>
      <div className="steps-header">
        <StepsIcon />
        <h6>
          <FormattedMessage id="life-id.steps" />
        </h6>
      </div>
      <div className="steps-body">
        <div className="steps-body__progress">
          <b className={data?.value ? 'count' : 'count empty'}>
            {data?.value ? Math.round(data?.value).toLocaleString() : '--'}
          </b>
          {percentage !== undefined ? (
            <CircleProgress
              percentage={percentage && percentage > 100 ? 100 : percentage}
              width={115}
              strokeWidth={10}
              secondaryColor="#EAEBF0"
              primaryColor={
                percentage && percentage >= 100
                  ? CIRCLE_CHART_GRADIENT_LEVELS[2]
                  : percentage === undefined
                  ? CIRCLE_CHART_GRADIENT_LEVELS[3]
                  : percentage && percentage >= 51
                  ? CIRCLE_CHART_GRADIENT_LEVELS[1]
                  : CIRCLE_CHART_GRADIENT_LEVELS[0]
              }
            />
          ) : (
            ''
          )}
        </div>
        <div className="steps-body__data">
          <div>
            <span>
              <FormattedMessage id="life_id.state" />
            </span>
            <b>{percentage ? percentage + '%' : '— —'}</b>
          </div>
          <div>
            <span>
              <FormattedMessage id="life-id.target" />
            </span>
            <b>{data?.goal ? Math.round(data?.goal) : '— —'}</b>
          </div>
        </div>
      </div>

      <div className="steps-footer">
        <Button size="SM" text="life_id.detail" onClick={onDetailOpen} disabled={isEmpty} />
        {data && (
          <Badge
            text={data?.source === 'Client' ? 'life-id.manually' : 'life-id.tracking'}
            type={data?.source === 'Client' ? 'Client' : ''}
            skipTranslation={false}
          />
        )}
      </div>
    </StepsWidgetSC>
  );
};

export default StepsWidget;
